exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card-header-right {\n    z-index: 999;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/numherit/PhpstormProjects/TEMPLATES/sunuprojet/src/app/shared/card/card.component.css
// module id = ../../../../../src/app/shared/card/card.component.css
// module chunks = main